<script>
  export let href = null
  export let current = false
</script>

{#if current}
  <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
  <li on:click on:keypress class="is-selected">
    <strong><slot /></strong>
  </li>
{:else}
  <li>
    <a on:click on:keypress {href} tabindex="0"><slot /></a>
  </li>
{/if}
